import type {LineRange} from '@github-ui/copilot-chat/utils/copilot-chat-types'

// scrape line numbers from rendered diff hunks
// potentially gives broader ranges (due to context and expansion lines)
// should only be used when we're missing range data and need it
export const scrapeFileDiffRange = (diffId: string, side: 'base' | 'head'): LineRange | undefined => {
  let selector = `[data-diff-anchor="${diffId}"] .js-linkable-line-number`

  switch (side) {
    case 'base':
      selector = `${selector}:not(.js-blob-rnum)`
      break
    case 'head':
      selector = `${selector}.js-blob-rnum`
      break
  }

  const baseLineNumberElements = [...document.querySelectorAll(selector)]
  const start = baseLineNumberElements[0]?.getAttribute('data-line-number')
  const end = baseLineNumberElements[baseLineNumberElements.length - 1]?.getAttribute('data-line-number')

  if (start && end) {
    return {start: parseInt(start), end: parseInt(end)}
  }
}
